import { render, staticRenderFns } from "./EmergencyNumbers.vue?vue&type=template&id=dece1306&scoped=true&"
import script from "./EmergencyNumbers.vue?vue&type=script&lang=js&"
export * from "./EmergencyNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dece1306",
  null
  
)

export default component.exports